import {gql} from 'apollo-angular';
import {StatusFragment} from "./fragments/Status";

export const START_GAME_TIMER = gql`
  query StartGameTimer($schoolClassId: Int!, $duration: Int!) {
    startGameTimer(schoolClassID: $schoolClassId, duration: $duration) {
      id
      schoolClassID
      startAt
      endAt
      duration
      createdAt
      status {
        ...statusFields
      }
    }

  }
  ${StatusFragment}
`;
